import * as React from 'react';
import { AuthProvider, AuthProvidersMap } from '../../entities/common';
import { Dropdown } from 'office-ui-fabric-react';

interface AuthProviderSelectProps {
    label?: string;
    disabled?: boolean;
    authProvider?: AuthProvider;
    onChange: (authProvider: AuthProvider) => void;
    visibleAuthProviders: AuthProvider[];
}

const AnyDefaultAuthProviderKey = "";

export const buildAllowedAuthProvidersOptions = (allowedAuthProviders: AuthProvider[]) => {
    return [
        { key: AnyDefaultAuthProviderKey, text: "Any" },
        ...allowedAuthProviders.map((_) => ({ key: _, text: AuthProvidersMap[_].friendlyName }))
    ]
}

const AuthProviderSelect = (props: AuthProviderSelectProps) => {
    const allowedAuthProvidersOptions = React.useMemo(() => buildAllowedAuthProvidersOptions(props.visibleAuthProviders), [props.visibleAuthProviders]);

    return <Dropdown
        label={props.label}
        disabled={props.disabled}
        selectedKey={props.authProvider ?? AnyDefaultAuthProviderKey}
        options={allowedAuthProvidersOptions}
        onChange={(e, _) => props.onChange(_!.key as AuthProvider)}
    />
};


export default (AuthProviderSelect);
